import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Paper, LinearProgress } from 'material-ui';
import { localize } from '../../../i18n';

const styles = {
  paper: {
    top: '48px',
    height: '52px',
    position: 'fixed',
    zIndex: 2,
    width: '100%',
    paddingTop: '4px',
    backgroundColor: '#F3F4F7',
  },
  tabItemContainer: {
    backgroundColor: '#F3F4F7',
  },
  tab: {
    fontSize: '11px',
    color: '#757575',
  },
  activeTab: {
    fontSize: '11px',
    color: '#004f94',
  },
  inkBar: {
    backgroundColor: '#004f94',
  },
  tabCounter: {
    position: 'absolute',
    top: 2,
    right: 0,
    width: 16,
    height: 16,
    backgroundColor: 'red',
    borderRadius: 8,
    fontSize: 10,
    lineHeight: '16px',
    color: 'white',
    fontWeight: 'bold',
  },
  progress: {
    borderRadius: 'none',
    position: 'absolute',
    top: '0',
  },
};

const ConversationTabs = ({ active, onChange, counters, isLoading, t }) => {
  const tabs = [
    {
      label: t('Due In'),
      value: 'due_in',
    },
    {
      label: t('Check In'),
      value: 'checked_in',
    },
    {
      label: t('In House'),
      value: 'in_house',
    },
    {
      label: t('Due Out'),
      value: 'due_out',
    },
    {
      label: t('Check Out'),
      value: 'checked_out',
    },
  ];

  const getTabLabel = tab => (
    <Fragment>
      <span>{tab.label}</span>
      {counters[tab.value] ?
        <span style={styles.tabCounter}>{counters[tab.value]}</span>
        : null
      }
    </Fragment>
  );

  return (
    <Paper zDepth={2} style={styles.paper}>
      {isLoading && <LinearProgress
        mode="indeterminate"
        color="#004f94"
        style={styles.progress}
      />}
      <Tabs
        tabItemContainerStyle={styles.tabItemContainer}
        inkBarStyle={styles.inkBar}
        value={active}
        onChange={onChange}
      >
        {tabs.map(tab => (
          <Tab
            style={active === tab.value ? styles.activeTab : styles.tab}
            key={tab.value}
            value={tab.value}
            label={getTabLabel(tab)}
          />
        ))}
      </Tabs>
    </Paper>
  );
};

ConversationTabs.propTypes = {
  active: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  counters: PropTypes.shape(),
  isLoading: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default localize(ConversationTabs);



// WEBPACK FOOTER //
// ./src/views/chat/components/ConversationTabs.js